<form [formGroup]="targetForm">
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2>Comment</h2>
        </div>
        <div class="drawer-close" (click)="closeDrawer()"><i class="fas fa-times"></i></div>
    </header>
    <section class="sideRight-body no-padding">
       <div *ngIf="!isArchived">
        <label>
            <textarea size="5" rows="7" cols="75" name="comment" no-special-chars="#!$%^<>+='" (blur)="trimSpecialChar('comment');" formControlName="comment" (input)= "onAddComment()" required class="textarea"></textarea>
        </label>
        <section class="btn-section">
            <button type='button' class="btn btn-secondary" [disabled]="!targetForm.valid || isDisabled" (click)="addComment()"><i class="fa fa-plus mr-2"></i> Add Comment</button> &nbsp;
            <button type='button' class="btn btn-success" [disabled]="isDisabled" *ngIf="resolvedStatus" (click)="resolveComment()"><i class="fa fa-check mr-2"></i> Resolve</button> &nbsp;
        </section>
       </div>
        <section class="comments-container info-tile-alt">
            <div class="comment-row" *ngFor="let item of comments">
                <div class="commented-time">{{item.commentedOn | tolocaldate}}</div>
                <div class="commented-by">{{item.commentedBy}}</div>
                <div class="comment">
                    <p>
                        {{item.comments}}
                    </p>
                </div>        
            </div>
        </section>
    </section>
</form>
